import React from 'react'
import { Icon,Tag } from 'antd';
import '../../css/svr_review_react.css'

export default  (props)=>{
    const {my_data_review} = props
    /*
     {
                                "rateKey": "20250615|20250616|W|1|297|DBL.ST|OPPRAIHBD|AI||1~1~0||N@07~~250f4~-186720143~N~~~NOR~~3E63FEAE94684DF174743279490405AAUK0003000100010721bd8",
                                "rateClass": "NOR",
                                "rateType": "BOOKABLE",
                                "net": "216.27",
                                "allotment": 24,
                                "rateCommentsId": "1|137844|0",
                                "paymentType": "AT_WEB",
                                "packaging": false,
                                "boardCode": "AI",
                                "boardName": "ALL INCLUSIVE",
                                "cancellationPolicies": [
                                    {
                                        "amount": "216.27",
                                        "from": "2025-06-07T23:59:00+02:00"
                                    }
                                ],
                                "taxes": {
                                    "taxes": [
                                        {
                                            "included": false,
                                            "amount": "3.30",
                                            "currency": "EUR",
                                            "clientAmount": "3.30",
                                            "clientCurrency": "EUR"
                                        }
                                    ],
                                    "allIncluded": false
                                },
                                "rooms": 1,
                                "adults": 1,
                                "children": 0,
                                "promotions": [
                                    {
                                        "code": "322",
                                        "name": "Online check-in"
                                    }
                                ]
                            }

    */
    //code start
    let Request = null
        if(my_data_review && my_data_review.Request){
            Request = my_data_review.Request
        }
        const stayWithUnits = (Request.stay? Request.stay: '6')  + ' ' + (Request.stayInit? Request.stayInit: 'nights') 
 

    //body start
    return (
        <div className="rev-row">
             <div className="card card--raised with-shadow">
                <p className="sd-content"> <text> Booking Details </text></p>
                <div className="box-outer">
                    <div className="rev-sd-left">
                        <p className="sd-check"><text>Check-in </text></p>
                        <p className="sd-content"><text style={{fontSize:'13px'}} >{Request.checkinTime?Request.checkinTime :'Tue, Dec 10, 2024 ' } </text></p>
                        <p className="sd-check"><text>{Request.checkinTimePrefix?Request.checkinTimePrefix :'From 3:00 PM' } </text></p>
                        <p className="sd-check"><text>Room Type </text></p>
                    </div>

                    <div className="rev-sd-right">

                        <p className="sd-check"><text>Check-out </text></p>
                        <p className="sd-content"><text style={{fontSize:'13px'}}>{Request.checkoutTime?Request.checkoutTime :'Fri, Dec 13, 2024' }  </text></p>
                        <p className="sd-check"><text>{Request.checkoutTimePrefix?Request.checkoutTimePrefix :'Until 11:00 AM' }  </text></p>
                        <p className="sd-check"><text>{Request.roomCode?Request.roomCode :'1 Double' } </text></p>
               
                    </div>

                </div>

                <p> <text> Total length of stay </text></p>
                <p> <text> {stayWithUnits? stayWithUnits:'6 nights' } </text></p>
            </div>
            </div>
)
}